// Fixed line heights keep the status stamp, user, and timestamp baselines aligned
// across the full table and the compact action-bar variant.
export const USER_PRIMARY_LINE_WRAPPER_CLASS = 'inline-flex min-h-[26px] w-full min-w-0 items-center';
export const ACTION_BAR_LINE_WRAPPER_CLASS = 'inline-flex min-h-[24px] w-full min-w-0 items-center';

// Horizontal inset that aligns action-bar rows with the surrounding card padding.
export const ACTION_BAR_ROW_INSET_CLASS = '!px-[calc(var(--spacing-s)+var(--spacing-m)-var(--spacing-xxs))]';

// Two-column grid (status + actor / trailing slot) used by the action-bar variant.
export const ACTION_BAR_AUDIT_COLUMN_WIDTHS = ['minmax(0, 1fr)', 'minmax(9rem, max-content)'] as const;
